import { useLocalStorage, httpClient } from '@gemini/fe-utils';
import {
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Loader } from '@gemini/lux-ds-pms';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

interface EnvironmentProps {
  brandName?: string;
  environmentConfig?: Record<string, string>;
}
const Environment = ({
  brandName,
  environmentConfig,
  children,
}: PropsWithChildren<EnvironmentProps>) => {
  const [isLoading, setIsLoading] = useState(true);
  const brandNameFromStore = useOnlineBookingStore(state => state.brandName);
  const brandNameInternal = useMemo(
    () => brandName || brandNameFromStore,
    [brandName, brandNameFromStore],
  );
  const url = process.env.ENV_URL || '/onlinebooking/environment.config.json';
  const [, setEnvConfig] = useLocalStorage<any>('env_config', null);

  const fetchEnvConfig = useCallback(() => {
    if (brandNameInternal && environmentConfig) {
      setEnvConfig(environmentConfig);
      setIsLoading(false);
    } else {
      // 2. Try to fetch config from server to merge it
      // If something goes wrong, fallback to baseConfig

      // TODO MANAGE ERROR
      httpClient(url, {
        isFromConfig: false,
        method: 'GET',
        isAuth: false,
      }).then(res => {
        setEnvConfig(res.data);
        setIsLoading(false);
        console.log('#EnvConfig:', res.data);
      });
    }
  }, [brandNameInternal, environmentConfig, setEnvConfig, url]);

  useEffect(() => {
    fetchEnvConfig();
  }, []);

  return <>{isLoading ? <Loader /> : children}</>;
};

export default Environment;
